// Backend statuses: requested, queued, completed, failed
// (api/data/models/data_export.py). Anything unknown stays neutral.
const STATUS = {
  requested: { label: 'Queued', tone: 'neutral' },
  queued: { label: 'Queued', tone: 'neutral' },
  processing: { label: 'Processing', tone: 'progress' },
  completed: { label: 'Ready', tone: 'success' },
  failed: { label: 'Failed', tone: 'danger' },
};

const TONE_CLASS = {
  neutral: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
  progress: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  success: 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300',
  danger: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
};

export const exportStatusDisplay = (status) => {
  const entry = STATUS[status] || { label: status || 'Unknown', tone: 'neutral' };
  return { label: entry.label, className: TONE_CLASS[entry.tone] };
};
